import { IconName } from "components/ui/Icon";

export const CARD_TRANSACTION_CATEGORY_ICON_MAP: {
  [category: string]: IconName;
} = {
  Advertising: "megaphone",
  "Air Travel": "plane",
  "Alcohol & Bars": "wine",
  Amusement: "rollerCoaster",
  Arts: "palette",
  "Auto Insurance": "accident",
  "Auto Payment": "car",
  "Auto & Transport": "carBus",
  "Babysitter & Daycare": "baby",
  "Bills & Utilities": "utilities",
  Books: "book",
  "Business Services": "briefcase",
  Cash: "wallet",
  Charity: "charity",
  Clothing: "shirt",
  "Coffee Shops": "coffee",
  "Credit Card Payment": "creditCard",
  Dentist: "tooth",
  Doctor: "doctor",
  "Domain Names": "globe",
  Education: "chalkboard",
  "Electronics & Software": "gadget",
  Entertainment: "popcorn",
  Eyecare: "glasses",
  "Fast Food": "hamburger",
  "Fees & Charges": "fee",
  Financial: "dollar",
  "Food & Dining": "utensils",
  "Food & Drink": "utensils",
  "Fraud Protection": "shield",
  Furnishings: "couch",
  Gas: "gasoline",
  Gift: "gift",
  "Gifts & Donations": "charity",
  Groceries: "grocery",
  Gym: "dumbbell",
  Hair: "scissors",
  "Health & Fitness": "spa",
  "Health Insurance": "doctor",
  Hobbies: "dice",
  Home: "house",
  "Home Improvement": "tools",
  "Home Insurance": "houseFire",
  "Home Services": "tools",
  Hosting: "globe",
  Hotel: "bed",
  Internet: "wifi",
  Investments: "dollarChart",
  Kids: "teddyBear",
  "Kids Activities": "faceLaughBeam",
  Laundry: "washer",
  "Lawn & Garden": "flowerTulip",
  Legal: "scale",
  "Life Insurance": "lifeRing",
  "Mobile Phone": "phone",
  "Mortgage & Rent": "building",
  "Movies & DVDs": "movieCamera",
  Music: "music",
  "Newspapers & Magazines": "newspaper",
  "Office Supplies": "stapler",
  Parking: "parking",
  "Personal Care": "spa",
  "Pet Food & Supplies": "dogLeashed",
  Pets: "veteranarian",
  Pharmacy: "pharmacy",
  Printing: "print",
  "Public Transportation": "train",
  "Rental Car & Taxi": "rental",
  Restaurants: "restaurant",
  "Service Fee": "fee",
  "Service & Parts": "tools",
  Shipping: "mailbox",
  Shopping: "shoppingBag",
  "Spa & Massage": "spa",
  "Sporting Goods": "baseball",
  Sports: "baseball",
  "Student Loan": "student",
  Taxes: "moneyBag",
  Television: "gadget",
  Toys: "teddyBear",
  Transfer: "transfer",
  Travel: "plane",
  Uncategorized: "shoppingBag",
  Utilities: "utilities",
  Vacation: "tropicalIsland",
  Veterinary: "veteranarian",
};
